module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var type = ['None','Solid'];
var size = [1,2,3,5,7,9];
var corner = [0,1,2,3,4,5,7,9];

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Border</span></div>\r\n<div class=\"row prop-detail\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6\">\r\n            <select name=\"borderStyle\" id=\"borderStyle\" >\r\n                ")
    ;  for (var i = 0; i < type.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(type[i].toLowerCase()))
    ; __append("\">")
    ; __append(escapeFn(type[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n        </div>\r\n        <div class=\"col-md-3 prop-sublabel\">\r\n            Size\r\n        </div>\r\n        <div class=\"col-md-2 nopadding\">\r\n            <select name=\"borderSize\" id=\"borderSize\" >\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n        </div>\r\n        <div class=\"col-md-1 prop-sublabel\" style=\"padding-left: 5px;\">\r\n            px\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" >\r\n        <div class=\"col-md-6\">\r\n            <input type=\"color\" id=\"borderColor\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.borderColorText ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input type=\"text\" name=\"border-color\" maxlength=\"7\" style=\"width: 75px; \" id=\"borderColorText\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.borderColorText  ))
    ; __append("\" />\r\n        </div>\r\n        <div class=\"col-md-4 prop-sublabel\" style=\"padding-right: 0;\">\r\n            Corner Radius\r\n        </div>\r\n        <div class=\"col-md-2\" style=\"padding-left: 0;padding-right: 0;\">\r\n            <select name=\"cornerRadius\" id=\"cornerRadius\" style=\"width: 40px;\">\r\n                ")
    ;  for (var i = 0; i < corner.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(corner[i]))
    ; __append("\">")
    ; __append(escapeFn(corner[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}